"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _FormattedReactMessage = _interopRequireDefault(require("I18n/components/FormattedReactMessage"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _TrialConstants = require("../../constants/TrialConstants");

var _ResultHeaderIllustration = _interopRequireDefault(require("./ResultHeaderIllustration"));

var _ResultSection = _interopRequireDefault(require("./ResultSection"));

var _PageScore = _interopRequireDefault(require("../PageScore"));

var _PreviewScreenshot = _interopRequireDefault(require("../PreviewScreenshot"));

var _Subtitle = _interopRequireDefault(require("../Subtitle"));

var _ScoreConstants = _interopRequireDefault(require("../../constants/ScoreConstants"));

var _MobileData = _interopRequireDefault(require("../../data/MobileData"));

var _ResultCtaBanner = _interopRequireDefault(require("../ResultCtaBanner"));

var _iphoneFrame = _interopRequireDefault(require("bender-url!../../../img/iphone-frame.png"));

var _Preview = require("../../selectors/Preview");

var _Urls = require("../../util/Urls");

var CTAButton = (0, _react.memo)(function () {
  var lang = window.I18N_MANUAL_LANG;
  var alt = lang !== 'en' ? '-alt' : '';
  var url = lang !== 'en' ? _TrialConstants.LanguageCTALinks[lang] : _TrialConstants.CTA_MOBILE;
  var parsedUtmParams = (0, _Urls.parseUtmParams)();
  return _react.default.createElement(_UILink.default, {
    href: url + "&" + parsedUtmParams,
    external: true
  }, _react.default.createElement(_FormattedHTMLMessage.default, {
    message: "results.mobile.cta.button" + alt
  }));
});

var _default = function _default(_ref) {
  var websiteGrade = _ref.websiteGrade;

  var _useSelector = (0, _reactRedux.useSelector)(_Preview.getMobilePreview, _reactRedux.shallowEqual),
      url = _useSelector.url,
      error = _useSelector.error; // Grade


  var grade = websiteGrade.get('mobileAudit').get('grade');
  return _react.default.createElement("div", {
    className: "full-page-centered mobile-page",
    id: "mobile"
  }, _react.default.createElement("div", {
    className: "flex-wrapper"
  }, _react.default.createElement("div", {
    className: "wsg-container"
  }, _react.default.createElement(_ResultHeaderIllustration.default, {
    name: "mobile-onboarding-powering-up"
  }), _react.default.createElement(_PageScore.default, {
    score: grade,
    overallScore: _ScoreConstants.default.MOBILE_OVERALL
  }), _react.default.createElement("h3", null, _react.default.createElement(_FormattedHTMLMessage.default, {
    message: "results.mobile.title"
  })), _react.default.createElement(_Subtitle.default, null, _react.default.createElement(_FormattedHTMLMessage.default, {
    message: "results.mobile.description"
  })), _react.default.createElement(_ResultCtaBanner.default, {
    use: "mobile"
  }, _react.default.createElement(_FormattedReactMessage.default, {
    message: "results.mobile.cta.info",
    options: {
      ctaButton: _react.default.createElement(CTAButton, null)
    }
  })), _react.default.createElement("div", {
    className: "results-section"
  }, _react.default.createElement(_PreviewScreenshot.default, {
    backgroundUrl: _iphoneFrame.default,
    previewUrl: url,
    error: error,
    isMobile: true
  }), _react.default.createElement("div", {
    className: "bg-blob"
  }, _react.default.createElement("div", {
    className: "mobile-card-flow"
  }, _react.default.createElement(_ResultSection.default, {
    websiteGrade: websiteGrade,
    results: _MobileData.default.results
  })))))));
};

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/pages/MobilePage.js
// module id = 296
// module chunks = 0